{
  "name": "Countdown Kill Button",
  "powerupName": "SkullSmasherTitle",
  "levelUpDescriptions": [
    "CountdownDestroyUpgradeDescription1",
    "CountdownDestroyUpgradeDescription2",
    "CountdownDestroyUpgradeDescription3",
    "CountdownDestroyUpgradeDescription4",
    "CountdownDestroyUpgradeDescription5"
  ]
}